// extracted by mini-css-extract-plugin
module.exports = {"washingRuleItem":"WashingRules_washingRuleItem__x0sd4","washingRuleDescription":"WashingRules_washingRuleDescription___J9TF","icon":"WashingRules_icon__aooc9"};